import React from 'react';
import { EXTERNAL_LINKS } from '../constants/business';
import { useAppinesDeeplinkConversion } from '../hooks/useAppinesDeeplinkConversion';

interface AppinesBannerProps {
  className?: string;
}

export default function AppinesBanner({ className = '' }: AppinesBannerProps) {
  const { handleClick } = useAppinesDeeplinkConversion(EXTERNAL_LINKS.APPINES_CAREER);

  return (
    <div className={`fixed top-0 left-0 right-0 z-50 md:relative md:mb-6 md:mx-auto md:max-w-5xl ${className}`}>
      <div className="bg-gradient-to-r from-appines-petrol to-appines-petrol md:rounded-xl shadow-lg overflow-hidden">
        <div className="px-3 py-3 sm:px-6 sm:py-4 md:px-8 md:py-6">
          <div className="flex items-center justify-between gap-2 sm:gap-4">
            {/* Logo et contenu */}
            <div className="flex items-center gap-2 sm:gap-4 flex-1">
              <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-appines-white rounded-full p-1.5 sm:p-2 flex-shrink-0">
                <img 
                  src="/logo-appines.png" 
                  alt="App'Ines" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="text-left flex-1 min-w-0">
                <h2 className="text-appines-white font-bold text-xs sm:text-sm md:text-lg leading-tight">
                  <span className="hidden sm:inline">Si on te trouve une cotation,  </span>
                  <span className="sm:hidden">Si on te trouve une cotation, </span>
                  <span className="text-appines-emerald">on doit bien pouvoir te trouver un rempla</span>
                </h2>
              </div>
            </div>
            
            {/* CTA */}
            <div className="flex-shrink-0 ml-2">
              <a
                href={EXTERNAL_LINKS.APPINES_CAREER}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClick}
                className="inline-flex items-center gap-1 px-2 py-1.5 sm:px-4 sm:py-2 md:px-6 md:py-3 bg-appines-emerald hover:bg-[#22b886] text-appines-petrol font-semibold rounded-md sm:rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl text-xs sm:text-sm md:text-base whitespace-nowrap"
              >
                <span className="hidden sm:inline">Trouver un rempla</span>
                <span className="sm:hidden">Trouver un rempla</span>
                <span>👉</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
